import $ from 'jquery';
import 'parsleyjs';

export async function initValidation(forms) {
    // require right lang based on html lang code
    let lang = 'en';

    switch (document.documentElement.getAttribute('lang')) {
        case 'de':
        case 'de-AT':
        case 'de-DE':
            lang = 'de';
            break;
    }

    await import(/* webpackInclude: /(de|en).js$/ */ 'parsleyjs/dist/i18n/' + lang); // TODO: include more languages when required

    // add parsley only to those forms, that should be validated
    $(forms).parsley({
        trigger: 'input change',
        triggerAfterFailure: 'input focusout change',
        errorClass: 'has-error',
        successClass: 'is-valid',
        errorsWrapper: '<ul></ul>',
        classHandler: ({ element }) => {
            let classHandler = element.closest('.input-group, .wpcf7-form-control-wrap, .floating-label');

            if (classHandler.matches('.wpcf7-form-control-wrap')) {
                return $(classHandler.querySelector('fieldset') || classHandler.querySelector('label'));
            }

            return $(classHandler ? classHandler : element);
        },
        errorsContainer: ({ element }) => {
            let rootEl = element.closest('.input-group, .wpcf7-form-control-wrap, .floating-label'),
                container = rootEl.querySelector('.form-errors');

            if (container === null) {
                container = rootEl;

                if (process.env.NODE_ENV !== 'production') {
                    console.group('[Template]');
                    console.error('Error-Containers must already exist at page-loading time');
                    console.log(element);
                    console.groupEnd();
                }
            }

            return $(container);
        },
    });

    window.Parsley.on('form:error', ({ element }) => {
        // remove the loading indicator if there was an error
        element.querySelectorAll('.is-loading').forEach((loader) => {
            loader.classList.remove('is-loading');
        });
    })
        .on('field:error', (Field) => {
            Field.element.setAttribute('aria-invalid', 'true');

            // bug in parsley.js: if 2 errors are on a field at the same time, and one gets removed,
            // aria-hidden is set to true
            Field.parent.options.errorsContainer(Field).find('ul').attr('aria-hidden', 'false');
        })
        .on('field:success', ({ element }) => {
            element.setAttribute('aria-invalid', 'false');
        });
}
